<p>
    {{statusText}}... 
    <mat-spinner [ngClass]="{'active': !error && !done}" strokeWidth="2" [diameter]="20"></mat-spinner>
    <span class="error" [ngClass]="{'active': error}">
        <mat-icon aria-hidden="false" aria-label="error icon">error</mat-icon>
    </span>
    <span class="done" [ngClass]="{'active': done}">
        <mat-icon aria-hidden="false" aria-label="done icon">done</mat-icon>
    </span>
</p>